import { render, staticRenderFns } from "./DropShadowTlIcon.vue?vue&type=template&id=2ffe972d&"
import script from "./DropShadowTlIcon.vue?vue&type=script&lang=js&"
export * from "./DropShadowTlIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports